const DEFAULT = Object.freeze({
  latest: null,
  locked: false,
  lockEnabled: null,
  lockError: false,
  lockToken: null,
  parsedToken: null,
  selectedSalonId: null,
  supportSalons: null,
  threshold: 0,
});

const determineState = (state) => state || { ...DEFAULT };

// noinspection JSUnusedGlobalSymbols
export default determineState;
